import './App.css';
import { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './views/Home/Home';
import ServicesGlobal from './views/Service/ServicesGlobal';
import ServiceTicket from './views/Service/Ticket/ServiceTicket';
import './locales/i18n'; // Importez la configuration
import smoothscroll from 'smoothscroll-polyfill';
import { useColorMode } from './components/ui/color-mode';
import Coding from './views/Service/Coding/coding';
import NotFound from './views/NotFoud';



const App = () => {

  const { setColorMode } = useColorMode()

  useEffect(() => {
    
    smoothscroll.polyfill();
    const hour = new Date().getHours()
    // Journée (8h-18h) : light, Soirée/Nuit : dark
    if (hour >= 8 && hour < 18) {
      setColorMode('light')
    } else {
      setColorMode('dark')
    }
  }, [])
  
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='*' element={<NotFound/>}/>
        <Route path="services">
          {/* Child routes */}
          <Route index element={<Home />} /> {/* Renders at /dashboard */}
          <Route path="voting" element={<ServicesGlobal />} /> {/* Renders at /dashboard/settings */}
          <Route path="tiketing" element={<ServiceTicket />} /> {/* Renders at /dashboard/analytics */}
          <Route path="coding" element={<Coding />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App